varying vec2 vUv;
varying vec3 vPosition;
varying vec3 vWorldPosition;
varying vec3 vNormalVector;

void main() {
  vUv = uv;
  vPosition = position;
  vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
  vNormalVector = normalize(normalMatrix * normal);
  //gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}